import {
  Users,
  CircleDollarSign,
  ShieldCheck,
  Trophy,
} from 'lucide-react';
import type { SpotlightFilterOption, SpotlightTabId } from './types';

export const SPOTLIGHT_TABS: {
  id: SpotlightTabId;
  label: string;
  icon: typeof Users;
}[] = [
  { id: 'attendance', label: 'Attendance', icon: Users },
  { id: 'labour', label: 'Labour', icon: CircleDollarSign },
  { id: 'compliance', label: 'Compliance', icon: ShieldCheck },
  { id: 'recognition', label: 'Recognition', icon: Trophy },
];

/** Single filter dropdown options — labels match Emp_SpotLight.xlsx / mockups. */
export const SPOTLIGHT_FILTERS: SpotlightFilterOption[] = [
  // Attendance
  { id: 'top-attendance', label: 'Top 5 Attendance %', tab: 'attendance' },
  { id: 'lowest-attendance', label: 'Lowest Attendance %', tab: 'attendance' },
  { id: 'most-late', label: 'Most Late Arrivals', tab: 'attendance' },
  { id: 'most-early', label: 'Most Early Clock Outs', tab: 'attendance' },
  { id: 'perfect-attendance', label: 'Perfect Attendance', tab: 'attendance' },
  { id: 'bradford-score', label: 'Highest Bradford Score', tab: 'attendance' },
  { id: 'most-sick-days', label: 'Most Sick Days', tab: 'attendance' },

  // Labour
  { id: 'most-hours', label: 'Most Hours Worked', tab: 'labour' },
  { id: 'least-hours', label: 'Least Hours Worked', tab: 'labour' },
  { id: 'most-overtime', label: 'Top 5 Highest Overtime (hrs)', tab: 'labour' },
  { id: 'highest-scheduled', label: 'Highest Scheduled Hours', tab: 'labour' },
  { id: 'highest-labour-cost', label: 'Highest Labour Cost', tab: 'labour' },
  { id: 'lowest-labour-cost', label: 'Lowest Labour Cost', tab: 'labour' },
  { id: 'best-break-compliance', label: 'Best Break Compliance', tab: 'labour' },
  { id: 'most-missed-breaks', label: 'Most Missed Breaks', tab: 'labour' },
  { id: 'highest-splh', label: 'Highest Revenue per Labour Hour', tab: 'labour' },
  { id: 'most-shift-swaps', label: 'Most Shift Swaps', tab: 'labour' },
  { id: 'most-extra-shifts', label: 'Most Extra Shifts Accepted', tab: 'labour' },
  { id: 'highest-shift-acceptance', label: 'Highest Shift Acceptance Rate', tab: 'labour' },

  // Compliance
  { id: 'docs-expiring', label: 'Top 5 Documents Expiring Soon', tab: 'compliance' },
  { id: 'docs-expired', label: 'Most Expired Documents', tab: 'compliance' },
  { id: 'fully-compliant', label: 'Fully Compliant Employees', tab: 'compliance' },
  { id: 'most-annual-leave-remaining', label: 'Most Annual Leave Remaining', tab: 'compliance' },

  // Recognition
  { id: 'employee-of-the-month', label: 'Top 5 Employee of the Month', tab: 'recognition' },
  { id: 'longest-service', label: 'Longest Service', tab: 'recognition' },
  { id: 'highest-rating', label: 'Highest Avg. Rating', tab: 'recognition' },
  { id: 'most-positive-notes', label: 'Most Positive Manager Notes', tab: 'recognition' },
  { id: 'most-commendations', label: 'Most Customer Commendations', tab: 'recognition' },
];

export function filtersForTab(tab: SpotlightTabId): SpotlightFilterOption[] {
  return SPOTLIGHT_FILTERS.filter((f) => f.tab === tab);
}

export function defaultFilterForTab(tab: SpotlightTabId): SpotlightFilterOption {
  return filtersForTab(tab)[0] ?? SPOTLIGHT_FILTERS[0];
}
